import React from 'react';
//import ComingSoon from './ComingSoon';
import Settings from '../AddressComplete/Settings';

const ProfileSettings = () => {
  return <Settings pageName="Settings" />;
  //return <ComingSoon pageName="Settings" />;
};

export default ProfileSettings;
